export default __webpack_public_path__ + "static/media/5.ef309b6e.webp";